var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsermanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 21.6667C22.75 19.7795 20.9408 18.1751 18.4167 17.5792M16.25 21.6667C16.25 19.2725 13.3402 17.3333 9.75 17.3333C6.15983 17.3333 3.25 19.2725 3.25 21.6667M16.25 14.0833C17.3993 14.0833 18.5015 13.6268 19.3141 12.8141C20.1268 12.0015 20.5833 10.8993 20.5833 9.74999C20.5833 8.60072 20.1268 7.49852 19.3141 6.68586C18.5015 5.8732 17.3993 5.41666 16.25 5.41666M9.75 14.0833C8.60073 14.0833 7.49853 13.6268 6.68587 12.8141C5.87321 12.0015 5.41667 10.8993 5.41667 9.74999C5.41667 8.60072 5.87321 7.49852 6.68587 6.68586C7.49853 5.8732 8.60073 5.41666 9.75 5.41666C10.8993 5.41666 12.0015 5.8732 12.8141 6.68586C13.6268 7.49852 14.0833 8.60072 14.0833 9.74999C14.0833 10.8993 13.6268 12.0015 12.8141 12.8141C12.0015 13.6268 10.8993 14.0833 9.75 14.0833Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagement);
export default __webpack_public_path__ + "static/media/usermanagement.d5122e417bb37da26b0d08720717219c.svg";
export { ForwardRef as ReactComponent };